import { Grid, makeStyles, Tooltip } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { FlashOn } from '@material-ui/icons';
import dateUtil from '../util/dateUtil';

const DateInput = ({ value, label, onChange, disabled, smallVersion, ...props }) => {
  const [selectedDate, setSelectedDate] = useState(dateUtil.stringToDate(value));

  useEffect(() => {
    setSelectedDate(dateUtil.stringToDate(value));
  }, [value]);

  const dateChange = (d) => {
    setSelectedDate(d);
    if (d && d != 'Invalid Date') {
      onChange(dateUtil.toDateString(d));
    }
  };

  const setNow = () => {
    onChange(dateUtil.nowDateString());
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container container style={{ position: 'relative' }}>
        <Grid item xs={12}>
          <KeyboardDatePicker
            variant="inline"
            margin="dense"
            label={label}
            id={props.id + '-date'}
            format="MM/dd/yy"
            value={selectedDate}
            error={props.error}
            helperText={props.helperText}
            autoOk={true}
            //style={{ marginRight: -7 }}
            onChange={dateChange}
            disabled={disabled}
            onFocus={(event) => event.target.select()}
            onBlur={() => {
              if (!selectedDate) {
                setSelectedDate(dateUtil.stringToDate(value));
              }
            }}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
          />
        </Grid>
        {!disabled && (
          <Grid className={'fab-show' + (smallVersion ? ' small' : '')} item xs={12}>
            <Tooltip title="Today">
              <FlashOn onClick={setNow} style={{ marginTop: 16 }} fontSize="small" />
            </Tooltip>
          </Grid>
        )}
      </Grid>
    </MuiPickersUtilsProvider>
  );
};

export default DateInput;
